// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3OkFD","buttons":"RemoveExpirationActionButtons_buttons__1bqXD"};